
import {
  DiceRollUpgradable,
} from "@dndModels/misc/DiceRollUpgradable";
import {
  UpgradableNumber,
} from "@dndModels";
import { RollPlus } from "@dndModels/misc/RollPlus";
import { DamageType, EffectType } from "@dndModels/Types";

export class RollPlusUpgradable extends DiceRollUpgradable {
  flat: UpgradableNumber = new UpgradableNumber();
  ability_score = "";
  as_string = "";
  type: EffectType | DamageType | "Attack" | "Recharge" = "None";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (typeof(obj) === "object") {
        this.flat = obj.flat ? new UpgradableNumber(obj.flat) : new UpgradableNumber();
        this.ability_score = obj.ability_score ? obj.ability_score : "";
        this.type = obj.type ? obj.type : "None";
      } else {
        this.flat = new UpgradableNumber(obj);
      }
    }
    this.as_string = "";
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      size: this.size.toDBObj(),
      count: this.count.toDBObj(),
      flat: this.flat.toDBObj(),
      ability_score: this.ability_score,
      type: this.type
    };
  }

  copy(copyMe: RollPlusUpgradable, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.flat = copyMe.flat.clone();
    this.ability_score = copyMe.ability_score;
    this.type = copyMe.type;
    this.as_string = "";
  }

  copyRollPlus(copyMe: RollPlus): void {
    this.size = new UpgradableNumber();
    this.size.base = copyMe.size;
    this.count = new UpgradableNumber(); 
    this.count.base = copyMe.count;
    this.flat =  new UpgradableNumber();
    this.flat.base = copyMe.flat;
    this.ability_score = copyMe.ability_score;
    this.type = copyMe.type;
    this.as_string = "";
  }

  clone(drop_ids = false): RollPlusUpgradable {
    const new_obj = new RollPlusUpgradable();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  get basic_string(): string {
    let str = "";
    if (this.count.isBasic() && this.size.isBasic() && this.flat.isBasic()) {
      if (this.count.base !== 0 && this.size.base > 0) {
        str = `${this.count.base}d${this.size.base}`;
      }
      if (str !== "" && this.flat.base > 0) {
        str += `+${this.flat.base}`;
      } else if (this.flat.base !== 0) {
        str += `${this.flat.base}`;
      }
    }
    return str;
  }

  isBlank = () => {
    return (this.flat.isBlank() && (this.count.isBlank() || this.size.isBlank()));
  }

  isBasic = () => {
    return (this.flat.isBasic() && this.count.isBasic() && this.size.isBasic());
  }

  makeBasic = () => {
    this.flat.makeBasic();
    this.count.makeBasic();
    this.size.makeBasic();
  }
}